import React, { useEffect, useRef } from "react";

const services = [
  {
    img: "/img/o1.png",
    title: "Battery Exchange",
    tamil: "பழைய பேட்டரி மாற்றீடு",
    desc: "பழைய பேட்டரியை மாற்றி புதிய Exide & Luminous பேட்டரியில் சிறப்பு தள்ளுபடி பெறுங்கள்",
  },
  {
    img: "/img/o2.png",
    title: "Doorstep Service",
    tamil: "டோர்-ஸ்டெப் சேவை",
    desc: "பேட்டரி சோதனை, சார்ஜிங் மற்றும் டெலிவரி — உங்கள் வீடு அல்லது கடைக்கே வருகிறோம்",
  },
  {
    img: "/img/o3.png",
    title: "Vehicle Audio Installation",
    tamil: "வாகன ஆடியோ அசெம்பிளி",
    desc: "டாடா ஏசி & ஆட்டோ வாகனங்களுக்கு தனிப்பயன் ஆம்ப்ளிஃபையர் & ஸ்பீக்கர் அசெம்பிளி",
  },
  {
    img: "/img/o4.png",
    title: "Repair & After-Sales",
    tamil: "பழுதுபார்ப்பு சேவை",
    desc: "விற்பனைக்குப் பின்னும் நேரடி தொழில்நுட்ப ஆதரவு — ஒவ்வொரு பொருளுக்கும் உறுதியான சேவை",
  },
  {
    img: "/img/o5.png",
    title: "Wholesale Supply",
    tamil: "மொத்த விற்பனை",
    desc: "தொழில்முறை வல்லுநர்கள் & டெக்னீஷியன்களுக்கு ஒவ்வொரு வருகையிலும் சிறப்பு மொத்த விலை",
  },
  {
    img: "/img/o6.png",
    title: "Weighing Scale Certification",
    tamil: "எடை இயந்திர அரசு சரிபார்ப்பு",
    desc: "அனைத்து வகை வணிக எடை இயந்திரங்களுக்கும் அரசு ஆய்வு, சரிபார்ப்பு மற்றும் சட்டப்பூர்வ முத்திரை பெற உதவுகிறோம்",
  },
];

export const Services = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" ref={sectionRef}>
      <div className="container">

        {/* ── Section Title ── */}
        <div className="section-title text-center">
          <h2>
            <span>Services</span>
            <hr style={{ margin: "10px auto 0", width: "70px" }} />
          </h2>
          <p>
            உங்கள் இல்லம் மற்றும் தொழிலுக்குத் தேவையான அனைத்தும் ஒரே இடத்தில்
          </p>
        </div>

        {/* ── Trader Banner ── */}
        <div className="trader-banner">
          <div className="trader-banner-left">
            <span className="trader-icon">⚖️</span>
            <div>
              <h4 className="trader-title">வியாபாரிகளுக்கான சிறப்பு சேவைகள்</h4>
              <p className="trader-sub">
                எங்கள் வணிக வளாகத்தில், வியாபாரிகளின் தேவைகளை கருத்தில் கொண்டு
                பல்வேறு சிறப்பு சேவைகள் வழங்கப்பட்டு வருகின்றன —
                சிறப்பு சலுகைகள், மொத்த விற்பனை வசதிகள் மற்றும்{" "}
                அரசு அங்கீகாரம் பெற்ற எடை இயந்திர சரிபார்ப்பு சேவை.
              </p>
            </div>
          </div>
        </div>

        {/* ── Services Grid ── */}
        <div className="services-grid">
          {services.map((s, i) => (
            <div
              className="service-card"
              key={i}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className="service-img">
                <img src={s.img} alt={s.title} className="service-img-photo" />
              </div>
              <div className="service-overlay">
                <h4 className="service-title">{s.title}</h4>
                <p className="service-tamil">{s.tamil}</p>
                <p className="service-desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};